export const COUNTRIES = [
  {
    id: 212,
    name: "United States",
    namePt: "Estados Unidos",
    nameEs: "Estados Unidos",
  },
  {
    id: 26,
    name: "Brazil",
    namePt: "Brasil",
    nameEs: "Brasil",
  },
  {
    id: 2,
    name: "Afghanistan",
    namePt: null,
    nameEs: null,
  },
  {
    id: 3,
    name: "Albania",
    namePt: null,
    nameEs: null,
  },
  {
    id: 4,
    name: "Algeria",
    namePt: null,
    nameEs: null,
  },
  {
    id: 5,
    name: "Andorra",
    namePt: null,
    nameEs: null,
  },
  {
    id: 6,
    name: "Angola",
    namePt: null,
    nameEs: null,
  },
  {
    id: 7,
    name: "Antigua and Barbuda",
    namePt: null,
    nameEs: null,
  },
  {
    id: 8,
    name: "Argentina",
    namePt: null,
    nameEs: null,
  },
  {
    id: 9,
    name: "Armenia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 10,
    name: "Aruba",
    namePt: null,
    nameEs: null,
  },
  {
    id: 11,
    name: "Australia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 12,
    name: "Austria",
    namePt: null,
    nameEs: null,
  },
  {
    id: 13,
    name: "Azerbaijan",
    namePt: null,
    nameEs: null,
  },
  {
    id: 14,
    name: "Bahamas, The",
    namePt: null,
    nameEs: null,
  },
  {
    id: 15,
    name: "Bahrain",
    namePt: null,
    nameEs: null,
  },
  {
    id: 16,
    name: "Bangladesh",
    namePt: null,
    nameEs: null,
  },
  {
    id: 17,
    name: "Barbados",
    namePt: null,
    nameEs: null,
  },
  {
    id: 18,
    name: "Belarus",
    namePt: null,
    nameEs: null,
  },
  {
    id: 19,
    name: "Belgium",
    namePt: null,
    nameEs: null,
  },
  {
    id: 20,
    name: "Belize",
    namePt: null,
    nameEs: null,
  },
  {
    id: 21,
    name: "Benin",
    namePt: null,
    nameEs: null,
  },
  {
    id: 22,
    name: "Bhutan",
    namePt: null,
    nameEs: null,
  },
  {
    id: 23,
    name: "Bolivia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 24,
    name: "Bosnia and Herzegovina",
    namePt: null,
    nameEs: null,
  },
  {
    id: 25,
    name: "Botswana",
    namePt: null,
    nameEs: null,
  },
  {
    id: 27,
    name: "Brunei",
    namePt: null,
    nameEs: null,
  },
  {
    id: 28,
    name: "Bulgaria",
    namePt: null,
    nameEs: null,
  },
  {
    id: 29,
    name: "Burkina Faso",
    namePt: null,
    nameEs: null,
  },
  {
    id: 30,
    name: "Burma",
    namePt: null,
    nameEs: null,
  },
  {
    id: 31,
    name: "Burundi",
    namePt: null,
    nameEs: null,
  },
  {
    id: 35,
    name: "Cabo Verde",
    namePt: null,
    nameEs: null,
  },
  {
    id: 32,
    name: "Cambodia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 33,
    name: "Cameroon",
    namePt: null,
    nameEs: null,
  },
  {
    id: 34,
    name: "Canada",
    namePt: null,
    nameEs: null,
  },
  {
    id: 36,
    name: "Central African Republic",
    namePt: null,
    nameEs: null,
  },
  {
    id: 37,
    name: "Chad",
    namePt: null,
    nameEs: null,
  },
  {
    id: 38,
    name: "Chile",
    namePt: null,
    nameEs: null,
  },
  {
    id: 39,
    name: "China",
    namePt: null,
    nameEs: null,
  },
  {
    id: 40,
    name: "Colombia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 41,
    name: "Comoros",
    namePt: null,
    nameEs: null,
  },
  {
    id: 42,
    name: "Congo, Democratic Republic of the",
    namePt: null,
    nameEs: null,
  },
  {
    id: 43,
    name: "Congo, Republic of the",
    namePt: null,
    nameEs: null,
  },
  {
    id: 44,
    name: "Costa Rica",
    namePt: null,
    nameEs: null,
  },
  {
    id: 45,
    name: "Cote dIvoire",
    namePt: null,
    nameEs: null,
  },
  {
    id: 46,
    name: "Croatia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 47,
    name: "Cuba",
    namePt: null,
    nameEs: null,
  },
  {
    id: 48,
    name: "Curacao",
    namePt: null,
    nameEs: null,
  },
  {
    id: 49,
    name: "Cyprus",
    namePt: null,
    nameEs: null,
  },
  {
    id: 50,
    name: "Czechia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 51,
    name: "Denmark",
    namePt: null,
    nameEs: null,
  },
  {
    id: 52,
    name: "Djibouti",
    namePt: null,
    nameEs: null,
  },
  {
    id: 53,
    name: "Dominica",
    namePt: null,
    nameEs: null,
  },
  {
    id: 54,
    name: "Dominican Republic",
    namePt: null,
    nameEs: null,
  },
  {
    id: 55,
    name: "East Timor (see Timor-Leste)",
    namePt: null,
    nameEs: null,
  },
  {
    id: 56,
    name: "Ecuador",
    namePt: null,
    nameEs: null,
  },
  {
    id: 57,
    name: "Egypt",
    namePt: null,
    nameEs: null,
  },
  {
    id: 58,
    name: "El Salvador",
    namePt: null,
    nameEs: null,
  },
  {
    id: 59,
    name: "Equatorial Guinea",
    namePt: null,
    nameEs: null,
  },
  {
    id: 60,
    name: "Eritrea",
    namePt: null,
    nameEs: null,
  },
  {
    id: 61,
    name: "Estonia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 62,
    name: "Eswatini",
    namePt: null,
    nameEs: null,
  },
  {
    id: 63,
    name: "Ethiopia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 64,
    name: "Fiji",
    namePt: null,
    nameEs: null,
  },
  {
    id: 65,
    name: "Finland",
    namePt: null,
    nameEs: null,
  },
  {
    id: 66,
    name: "France",
    namePt: null,
    nameEs: null,
  },
  {
    id: 67,
    name: "Gabon",
    namePt: null,
    nameEs: null,
  },
  {
    id: 68,
    name: "Gambia, The",
    namePt: null,
    nameEs: null,
  },
  {
    id: 69,
    name: "Georgia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 70,
    name: "Germany",
    namePt: null,
    nameEs: null,
  },
  {
    id: 71,
    name: "Ghana",
    namePt: null,
    nameEs: null,
  },
  {
    id: 72,
    name: "Greece",
    namePt: null,
    nameEs: null,
  },
  {
    id: 73,
    name: "Grenada",
    namePt: null,
    nameEs: null,
  },
  {
    id: 74,
    name: "Guatemala",
    namePt: null,
    nameEs: null,
  },
  {
    id: 75,
    name: "Guinea",
    namePt: null,
    nameEs: null,
  },
  {
    id: 76,
    name: "Guinea-Bissau",
    namePt: null,
    nameEs: null,
  },
  {
    id: 77,
    name: "Guyana",
    namePt: null,
    nameEs: null,
  },
  {
    id: 78,
    name: "Haiti",
    namePt: null,
    nameEs: null,
  },
  {
    id: 79,
    name: "Holy See",
    namePt: null,
    nameEs: null,
  },
  {
    id: 80,
    name: "Honduras",
    namePt: null,
    nameEs: null,
  },
  {
    id: 81,
    name: "Hong Kong",
    namePt: null,
    nameEs: null,
  },
  {
    id: 82,
    name: "Hungary",
    namePt: null,
    nameEs: null,
  },
  {
    id: 83,
    name: "Iceland",
    namePt: null,
    nameEs: null,
  },
  {
    id: 84,
    name: "India",
    namePt: null,
    nameEs: null,
  },
  {
    id: 85,
    name: "Indonesia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 86,
    name: "Iran",
    namePt: null,
    nameEs: null,
  },
  {
    id: 87,
    name: "Iraq",
    namePt: null,
    nameEs: null,
  },
  {
    id: 88,
    name: "Ireland",
    namePt: null,
    nameEs: null,
  },
  {
    id: 89,
    name: "Israel",
    namePt: null,
    nameEs: null,
  },
  {
    id: 90,
    name: "Italy",
    namePt: null,
    nameEs: null,
  },
  {
    id: 91,
    name: "Jamaica",
    namePt: null,
    nameEs: null,
  },
  {
    id: 92,
    name: "Japan",
    namePt: null,
    nameEs: null,
  },
  {
    id: 93,
    name: "Jordan",
    namePt: null,
    nameEs: null,
  },
  {
    id: 94,
    name: "Kazakhstan",
    namePt: null,
    nameEs: null,
  },
  {
    id: 95,
    name: "Kenya",
    namePt: null,
    nameEs: null,
  },
  {
    id: 96,
    name: "Kiribati",
    namePt: null,
    nameEs: null,
  },
  {
    id: 97,
    name: "Korea, North",
    namePt: null,
    nameEs: null,
  },
  {
    id: 98,
    name: "Korea, South",
    namePt: null,
    nameEs: null,
  },
  {
    id: 99,
    name: "Kosovo",
    namePt: null,
    nameEs: null,
  },
  {
    id: 100,
    name: "Kuwait",
    namePt: null,
    nameEs: null,
  },
  {
    id: 101,
    name: "Kyrgyzstan",
    namePt: null,
    nameEs: null,
  },
  {
    id: 102,
    name: "Laos",
    namePt: null,
    nameEs: null,
  },
  {
    id: 103,
    name: "Latvia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 104,
    name: "Lebanon",
    namePt: null,
    nameEs: null,
  },
  {
    id: 105,
    name: "Lesotho",
    namePt: null,
    nameEs: null,
  },
  {
    id: 106,
    name: "Liberia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 107,
    name: "Libya",
    namePt: null,
    nameEs: null,
  },
  {
    id: 108,
    name: "Liechtenstein",
    namePt: null,
    nameEs: null,
  },
  {
    id: 109,
    name: "Lithuania",
    namePt: null,
    nameEs: null,
  },
  {
    id: 110,
    name: "Luxembourg",
    namePt: null,
    nameEs: null,
  },
  {
    id: 111,
    name: "Macau",
    namePt: null,
    nameEs: null,
  },
  {
    id: 112,
    name: "Macedonia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 113,
    name: "Madagascar",
    namePt: null,
    nameEs: null,
  },
  {
    id: 114,
    name: "Malawi",
    namePt: null,
    nameEs: null,
  },
  {
    id: 115,
    name: "Malaysia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 116,
    name: "Maldives",
    namePt: null,
    nameEs: null,
  },
  {
    id: 117,
    name: "Mali",
    namePt: null,
    nameEs: null,
  },
  {
    id: 118,
    name: "Malta",
    namePt: null,
    nameEs: null,
  },
  {
    id: 119,
    name: "Marshall Islands",
    namePt: null,
    nameEs: null,
  },
  {
    id: 120,
    name: "Mauritania",
    namePt: null,
    nameEs: null,
  },
  {
    id: 121,
    name: "Mauritius",
    namePt: null,
    nameEs: null,
  },
  {
    id: 122,
    name: "Mexico",
    namePt: null,
    nameEs: null,
  },
  {
    id: 123,
    name: "Micronesia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 124,
    name: "Moldova",
    namePt: null,
    nameEs: null,
  },
  {
    id: 125,
    name: "Monaco",
    namePt: null,
    nameEs: null,
  },
  {
    id: 126,
    name: "Mongolia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 127,
    name: "Montenegro",
    namePt: null,
    nameEs: null,
  },
  {
    id: 128,
    name: "Morocco",
    namePt: null,
    nameEs: null,
  },
  {
    id: 129,
    name: "Mozambique",
    namePt: null,
    nameEs: null,
  },
  {
    id: 130,
    name: "Namibia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 131,
    name: "Nauru",
    namePt: null,
    nameEs: null,
  },
  {
    id: 132,
    name: "Nepal",
    namePt: null,
    nameEs: null,
  },
  {
    id: 133,
    name: "Netherlands",
    namePt: null,
    nameEs: null,
  },
  {
    id: 134,
    name: "New Zealand",
    namePt: null,
    nameEs: null,
  },
  {
    id: 135,
    name: "Nicaragua",
    namePt: null,
    nameEs: null,
  },
  {
    id: 136,
    name: "Niger",
    namePt: null,
    nameEs: null,
  },
  {
    id: 137,
    name: "Nigeria",
    namePt: null,
    nameEs: null,
  },
  {
    id: 138,
    name: "North Korea",
    namePt: null,
    nameEs: null,
  },
  {
    id: 139,
    name: "Norway",
    namePt: null,
    nameEs: null,
  },
  {
    id: 140,
    name: "Oman",
    namePt: null,
    nameEs: null,
  },
  {
    id: 141,
    name: "Pakistan",
    namePt: null,
    nameEs: null,
  },
  {
    id: 142,
    name: "Palau",
    namePt: null,
    nameEs: null,
  },
  {
    id: 143,
    name: "Palestinian Territories",
    namePt: null,
    nameEs: null,
  },
  {
    id: 144,
    name: "Panama",
    namePt: null,
    nameEs: null,
  },
  {
    id: 145,
    name: "Papua New Guinea",
    namePt: null,
    nameEs: null,
  },
  {
    id: 146,
    name: "Paraguay",
    namePt: null,
    nameEs: null,
  },
  {
    id: 147,
    name: "Peru",
    namePt: null,
    nameEs: null,
  },
  {
    id: 148,
    name: "Philippines",
    namePt: null,
    nameEs: null,
  },
  {
    id: 149,
    name: "Poland",
    namePt: null,
    nameEs: null,
  },
  {
    id: 150,
    name: "Portugal",
    namePt: null,
    nameEs: null,
  },
  {
    id: 151,
    name: "Qatar",
    namePt: null,
    nameEs: null,
  },
  {
    id: 152,
    name: "Romania",
    namePt: null,
    nameEs: null,
  },
  {
    id: 153,
    name: "Russia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 154,
    name: "Rwanda",
    namePt: null,
    nameEs: null,
  },
  {
    id: 155,
    name: "Saint Kitts and Nevis",
    namePt: null,
    nameEs: null,
  },
  {
    id: 156,
    name: "Saint Lucia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 157,
    name: "Saint Vincent and the Grenadines",
    namePt: null,
    nameEs: null,
  },
  {
    id: 158,
    name: "Samoa",
    namePt: null,
    nameEs: null,
  },
  {
    id: 159,
    name: "San Marino",
    namePt: null,
    nameEs: null,
  },
  {
    id: 160,
    name: "Sao Tome and Principe",
    namePt: null,
    nameEs: null,
  },
  {
    id: 161,
    name: "Saudi Arabia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 162,
    name: "Senegal",
    namePt: null,
    nameEs: null,
  },
  {
    id: 163,
    name: "Serbia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 164,
    name: "Seychelles",
    namePt: null,
    nameEs: null,
  },
  {
    id: 165,
    name: "Sierra Leone",
    namePt: null,
    nameEs: null,
  },
  {
    id: 166,
    name: "Singapore",
    namePt: null,
    nameEs: null,
  },
  {
    id: 167,
    name: "Sint Maarten",
    namePt: null,
    nameEs: null,
  },
  {
    id: 168,
    name: "Slovakia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 169,
    name: "Slovenia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 170,
    name: "Solomon Islands",
    namePt: null,
    nameEs: null,
  },
  {
    id: 171,
    name: "Somalia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 172,
    name: "South Africa",
    namePt: null,
    nameEs: null,
  },
  {
    id: 173,
    name: "South Korea",
    namePt: null,
    nameEs: null,
  },
  {
    id: 174,
    name: "South Sudan",
    namePt: null,
    nameEs: null,
  },
  {
    id: 175,
    name: "Spain",
    namePt: null,
    nameEs: null,
  },
  {
    id: 176,
    name: "Sri Lanka",
    namePt: null,
    nameEs: null,
  },
  {
    id: 177,
    name: "Sudan",
    namePt: null,
    nameEs: null,
  },
  {
    id: 178,
    name: "Suriname",
    namePt: null,
    nameEs: null,
  },
  {
    id: 179,
    name: "Swaziland (See Eswatini)",
    namePt: null,
    nameEs: null,
  },
  {
    id: 180,
    name: "Sweden",
    namePt: null,
    nameEs: null,
  },
  {
    id: 181,
    name: "Switzerland",
    namePt: null,
    nameEs: null,
  },
  {
    id: 182,
    name: "Syria",
    namePt: null,
    nameEs: null,
  },
  {
    id: 183,
    name: "Taiwan",
    namePt: null,
    nameEs: null,
  },
  {
    id: 184,
    name: "Tajikistan",
    namePt: null,
    nameEs: null,
  },
  {
    id: 185,
    name: "Tanzania",
    namePt: null,
    nameEs: null,
  },
  {
    id: 186,
    name: "Thailand",
    namePt: null,
    nameEs: null,
  },
  {
    id: 187,
    name: "Timor-Leste",
    namePt: null,
    nameEs: null,
  },
  {
    id: 188,
    name: "Togo",
    namePt: null,
    nameEs: null,
  },
  {
    id: 189,
    name: "Tonga",
    namePt: null,
    nameEs: null,
  },
  {
    id: 190,
    name: "Trinidad and Tobago",
    namePt: null,
    nameEs: null,
  },
  {
    id: 191,
    name: "Tunisia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 192,
    name: "Turkey",
    namePt: null,
    nameEs: null,
  },
  {
    id: 193,
    name: "Turkmenistan",
    namePt: null,
    nameEs: null,
  },
  {
    id: 194,
    name: "Tuvalu",
    namePt: null,
    nameEs: null,
  },
  {
    id: 195,
    name: "Uganda",
    namePt: null,
    nameEs: null,
  },
  {
    id: 196,
    name: "Ukraine",
    namePt: null,
    nameEs: null,
  },
  {
    id: 197,
    name: "United Arab Emirates",
    namePt: null,
    nameEs: null,
  },
  {
    id: 198,
    name: "United Kingdom",
    namePt: null,
    nameEs: null,
  },
  {
    id: 199,
    name: "Uruguay",
    namePt: null,
    nameEs: null,
  },
  {
    id: 200,
    name: "Uzbekistan",
    namePt: null,
    nameEs: null,
  },
  {
    id: 201,
    name: "Vanuatu",
    namePt: null,
    nameEs: null,
  },
  {
    id: 202,
    name: "Venezuela",
    namePt: null,
    nameEs: null,
  },
  {
    id: 203,
    name: "Vietnam",
    namePt: null,
    nameEs: null,
  },
  {
    id: 204,
    name: "Yemen",
    namePt: null,
    nameEs: null,
  },
  {
    id: 205,
    name: "Zambia",
    namePt: null,
    nameEs: null,
  },
  {
    id: 206,
    name: "Zimbabwe",
    namePt: null,
    nameEs: null,
  },
  {
    id: 999,
    name: "Other",
    namePt: "Other",
    nameEs: "Other",
  },
];
